import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconTreeSvg } from "./IconTreeSvg.mjs";
const IconTree = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconTreeSvg, ...iconProps });
};
export {
  IconTree
};
